import { render, staticRenderFns } from "./UserDetectDoubles.vue?vue&type=template&id=4fce17aa&"
import script from "./UserDetectDoubles.vue?vue&type=script&lang=js&"
export * from "./UserDetectDoubles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/samenaankoop/src/vue-apps/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fce17aa')) {
      api.createRecord('4fce17aa', component.options)
    } else {
      api.reload('4fce17aa', component.options)
    }
    module.hot.accept("./UserDetectDoubles.vue?vue&type=template&id=4fce17aa&", function () {
      api.rerender('4fce17aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/pages/UserDetectDoubles.vue"
export default component.exports